//import GoogleMapsComponent from "../../components/GoogleMapsComponent/GoogleMapsComponent";
import { useTranslation } from "react-i18next";
import { Await, useLoaderData } from "react-router-dom";
import { Suspense, useState } from "react";
import { FarmsMap } from "./FarmsMap";
/* import { Accordion, AccordionTab } from "primereact/accordion";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner"; */
import { MapOptions, LoadingMapOptions } from "../../components/MapOptions/MapOptions";
import FarmsTable from "./FarmsTable";
import Summary from "./Summary";
import "./Main.scss";

const Map = () => {
    const { t } = useTranslation();
    const deferData = useLoaderData();

    const [farmsSelected, setFarmsSelected] = useState([]);
    const [selectDisplay, setselectDisplay] = useState({ label: t("map.map") });


    return (
        <div>
            <Suspense fallback={<LoadingMapOptions />}>
                <Await resolve={deferData.farms}>
                    <>
                        <MapOptions
                            setFarmsSelected={setFarmsSelected}
                            selectDisplay={selectDisplay}
                            setselectDisplay={setselectDisplay}
                        />
                        {selectDisplay.label === t("map.table") ? <FarmsTable farms={farmsSelected} /> : null}
                        {selectDisplay.label === t("map.summary") ? <Summary farms={farmsSelected} /> : null}
                    </>
                </Await>
            </Suspense>
            <FarmsMap farms={farmsSelected} hidden={selectDisplay.label === t("map.map") ? false : true } />
        </div>
    );
};

export default Map;
